import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CmsConfig, ConfigModule, I18nModule, provideDefaultConfig, UrlModule
} from '@spartacus/core';
import {
  ActiveFacetsModule,
  CartSharedModule,
  FacetListModule,
  FormErrorsModule,
  IconModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  ProgressButtonModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { EkCheckoutOrderSummaryComponent } from './checkout-order-summary.component';
import { CheckoutOrderSummaryService } from './checkout-order-summary.service';

@NgModule({
  imports: [
    CommonModule,
    CartSharedModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FacetListModule,
    FormsModule,
    ProgressButtonModule,
    ReactiveFormsModule,
    FormErrorsModule,
    ActiveFacetsModule,
    IconModule,
    I18nModule,
    UrlModule,
    RouterModule,
    SpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutOrderSummaryComponent: {
          component: EkCheckoutOrderSummaryComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutOrderSummaryComponent: {
          component: EkCheckoutOrderSummaryComponent,
        },
      },
    }),CheckoutOrderSummaryService
  ],
  // providers: [
  //   // provideOutlet({
  //   //   id: 'MultiStepCheckoutSummaryPageTemplate',
  //   //   position: OutletPosition.REPLACE,
  //   //   component: EkCheckoutOrderSummaryComponent,
  //   // }),
  //   provideDefaultConfig(<CmsConfig>{
  //     cmsComponents: {
  //       CheckoutReviewOrderComponent: EkCheckoutOrderSummaryComponent,
  //     },
  //   }),
  // ],
  exports: [EkCheckoutOrderSummaryComponent],
  declarations: [EkCheckoutOrderSummaryComponent],
})
export class CheckoutOrderSummaryModule {}
